import { useQuery } from '@tanstack/react-query';
import { getWishlistCount } from '../../api/apiStorefront';
import { useAuthContext } from '../../auth/useAuthContext';

export const useGetWishlistCount = () => {
  const { isAuthenticated } = useAuthContext();

  return useQuery({
    queryKey: ['wishlist-count'],
    queryFn: async () => {
      const response = await getWishlistCount();
      return response?.data?.data?.count || 0; // Return the count value directly
    },
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
};
